<template>
  <settings-modal class="sepa-operation-cancel-modal t-sepa-operation-cancel-modal">
    <template slot="heading">Cancel operation {{ operationId }}</template>

    <scrollable-container slot="raw">
      <div>
        <data-row>
          <v-flex>
            <one-data-column
              :label-props="{ style: 'display: none;' }"
              :data-props="{ style: 'min-width: auto' }"
            >
              <v-select
                id="cancel-reason"
                v-model="form.reason"
                class="sepa-operation-cancel-modal__reason-select"
                :menu-props="{contentClass: 'sepa-operation-cancel-modal__reason-select-menu'}"
                :items="cancelReasonOptions"
                item-text="value"
                item-value="value"
                label="Cancel reason"
                :error-messages="getValidationErrorMessage('reason')"
              >
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ data.item.value }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ data.item.name }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-select>
            </one-data-column>
          </v-flex>
        </data-row>

        <error-alert :error="error" />
      </div>
    </scrollable-container>

    <template slot="actions">
      <v-btn
        class="t-make-cancel"
        color="light-blue darken-3"
        flat
        :disabled="!isFormFilled || loading"
        @click="onMakeCancelButtonClick"
      >make cancel</v-btn>

      <v-btn
        class="t-close-modal"
        color="light-blue darken-3"
        flat
        @click="closeModal"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Data
  import cancelReasons from '@/assets/data/sepa/cancel-reasons'

  // Events
  import { EVENT_OPERATION_UPDATE } from '@/events/operations'

  // Mixins
  import form from '@/mixins/form'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ScrollableContainer from '@/components/ui/ScrollableContainer'
  import DataRow from '@/components/ui/Data/DataRow'
  import OneDataColumn from '@/components/ui/Data/OneDataColumn'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'SepaOperationCancelModal',
    components: {
      SettingsModal,
      ScrollableContainer,
      DataRow,
      OneDataColumn,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: { reason: null },
        sepaWithdrawalCancelApiRequest: new ApiRequest(PaymentApi.cancelSepaWithdrawalOperation),
        requiredFields: ['reason']
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentId () {
        return this.modal.data.paymentId
      },
      operationId () {
        return this.modal.data.operationId
      },
      cancelReasonOptions () {
        return Object.keys(cancelReasons).map(code => ({
          name: cancelReasons[code],
          value: code
        }))
      },
      loading () {
        return this.sepaWithdrawalCancelApiRequest.loading
      },
      error () {
        return this.sepaWithdrawalCancelApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['closeModal', 'showModal']),
      onMakeCancelButtonClick () {
        this.cancelSepaOperation()
          .then(() => {
            this.$eventHub.$emit(EVENT_OPERATION_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Operation has been successfully cancelled.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      cancelSepaOperation () {
        return this.sepaWithdrawalCancelApiRequest.execute(
          this.paymentId,
          this.operationId,
          this.form.reason
        )
      }
    }
  }
</script>

<style lang="scss">
  .sepa-operation-cancel-modal {
    &.settings-modal {
      .container {
        padding-bottom: 28px;
      }
    }

    &__reason-select-menu {
      .v-list__tile {
        height: 52px;
      }
    }
  }
</style>
